import { render, staticRenderFns } from "./Escala.vue?vue&type=template&id=dfaa07ee&scoped=true"
import script from "./Escala.vue?vue&type=script&lang=js"
export * from "./Escala.vue?vue&type=script&lang=js"
import style0 from "./Escala.vue?vue&type=style&index=0&id=dfaa07ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaa07ee",
  null
  
)

export default component.exports